import instance from "./instancev2";

export function postTagProtocol(data) {
  return instance.post(`/protocol/tag`, data);
}

export function putTagProtocol(data) {
  return instance.put(`/protocol/tag`, data);
}
